<script>
export default {
  name: "ActivityTable",
  props: {
    activities: {
      type: Array,
      required: true,
    }
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const day = String(date.getDate()).padStart(2, '0');
      const month = date.toLocaleString('default', {month: 'short'});
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');

      return `${day} ${month} ${year}, ${hours}:${minutes}`;
    }
  }
}
</script>

<template>
  <table class="table">
    <thead>
    <tr>
      <td class="title">Action</td>
      <td class="title">Country</td>
      <td class="title">IP address</td>
      <td class="title">Date</td>
      <td class="title">Source info</td>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(item, i) in activities" :key="i">
      <td class="desc">{{ item.action }}</td>
      <td class="desc">{{ item.country || '-' }}</td>
      <td class="desc">{{ item.ip }}</td>
      <td class="desc">{{ formatDate(item.created_at) }}</td>
      <td class="desc">{{ item.source_info }}</td>
    </tr>
    </tbody>
  </table>
</template>

<style scoped>

</style>